import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import { leafletBoundsToArea } from '../utils/mapSearchArea';

/**
 * Centers map on searched place and reports viewport changes for "Search this area".
 */
const MapSearchAreaControl = ({ searchPlace, onMapMoved }) => {
  const map = useMap();
  const lastFlyKey = useRef(null);
  const suppressMoveRef = useRef(false);

  useEffect(() => {
    if (!searchPlace?.center) return;
    const key = `${searchPlace.label}-${searchPlace.center.lat}-${searchPlace.center.lng}`;
    if (lastFlyKey.current === key) return;
    lastFlyKey.current = key;

    suppressMoveRef.current = true;
    window.setTimeout(() => {
      suppressMoveRef.current = false;
    }, 700);

    if (searchPlace.bounds) {
      const { south, west, north, east } = searchPlace.bounds;
      map.fitBounds(
        [
          [south, west],
          [north, east],
        ],
        { padding: [48, 48], maxZoom: 14, animate: true }
      );
      return;
    }

    map.setView(
      [searchPlace.center.lat, searchPlace.center.lng],
      searchPlace.zoom || 12,
      { animate: true }
    );
  }, [map, searchPlace]);

  useEffect(() => {
    const emitMove = () => {
      if (suppressMoveRef.current) return;
      const bounds = leafletBoundsToArea(map.getBounds());
      const center = map.getCenter();
      onMapMoved?.({
        bounds,
        center: { lat: center.lat, lng: center.lng },
        zoom: map.getZoom(),
      });
    };

    map.on('moveend', emitMove);
    map.on('zoomend', emitMove);
    return () => {
      map.off('moveend', emitMove);
      map.off('zoomend', emitMove);
    };
  }, [map, onMapMoved]);

  return null;
};

export default MapSearchAreaControl;
